<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h3 class="headings">VAMP Details</h3>
    </div>
  </div>

  <!-- ===== Summary — single details card; zeros/defaults when empty ===== -->
  <div class="b_shadow mt-3">
    <div class="heading-card">
      <div class="row">
        <div class="col-12 left-heading pl-xl-5 pl-lg-5 pl-sm-5"><span>Summary</span></div>
      </div>
    </div>
    <div class="px-xl-5 px-lg-5 px-sm-4 px-3 py-xl-4 py-lg-4 py-3">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-12" *ngFor="let field of summaryFields">
          <div class="vamp-field">
            <span class="vamp-field-label">{{ field.label }}</span>
            <span class="vamp-field-value" [ngSwitch]="field.type">
              <span *ngSwitchCase="'money'">{{ displaySummary[field.key] != null ? (displaySummary[field.key] | currency:'USD':'symbol':'1.2-2') : '$0.00' }}</span>
              <span *ngSwitchCase="'number'">{{ displaySummary[field.key] != null ? (displaySummary[field.key] | number) : 0 }}</span>
              <span *ngSwitchCase="'percent'">{{ displaySummary[field.key] != null ? (displaySummary[field.key] | number:'1.2-4') + '%' : '0.00%' }}</span>
              <span *ngSwitchDefault>{{ displaySummary[field.key] != null && displaySummary[field.key] !== '' ? displaySummary[field.key] : '--' }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== TC-40 transactions ===== -->
  <div class="payment_bdy">
    <div class="table_content mt-xl-3 mt-lg-3 mt-md-3">

      <div class="row px-xl-4 px-lg-4 px-md-4 py-4">
        <div class="col-lg-4 col-xl-4 col-md-12 col-sm-12 col-12 form-group has-search mb-0">
          <span class="fa fa-search form-control-feedback"></span>
          <input type="search" class="form-control search-bar col-12 py-2"
                 [(ngModel)]="searchText" (input)="searchHits.next()" placeholder="Search"/>
        </div>
        <div class="col-lg-5 col-xl-5 col-md-12 col-sm-9 col-8 mb-md-2 mob_calendar mb-xl-0 mb-lg-0">
          <div class="row">
            <input type="text" [(ngModel)]="from"
                   class="form-control calander-input-icon col-xl-5 col-md-5 col-5 ml-md-3 mr-xl-3 mr-m-7"
                   [matDatepicker]="df" [max]="to"
                   placeholder="From" (click)="df.open()" readonly>
            <mat-datepicker #df (closed)="onDateChange()"></mat-datepicker>
            <input type="text" [(ngModel)]="to"
                   class="form-control calander-input-icon col-xl-5 col-md-6 col-5 mob_text"
                   [matDatepicker]="dt" placeholder="To" [max]="today"
                   [min]="from" (click)="dt.open()" readonly>
            <mat-datepicker #dt (closed)="onDateChange()"></mat-datepicker>
          </div>
        </div>
        <div class="col-lg-3 col-xl-3 col-md-12 col-sm-3 col-4 text-right">
          <button class="export_btn" [disabled]="!totalRecords" (click)="export('csv')">Export CSV</button>
          <button class="export_btn ml-2" [disabled]="!totalRecords" (click)="export('xls')">Export XLS</button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-m-0">
          <div (scroll)='scrollcontent("TopScroll", "scrollContent")' *ngIf="!loadFlag2" class="top-scroll" id="TopScroll">
            <img src="" alt="" height=1 [style]="checkTablewidth()">
          </div>
          <div class="table-responsive table-height" (scroll)='scrollcontent("scrollContent", "TopScroll")' id="scrollContent">
            <table class="table mb-0" id="table-width">
              <thead>
                <tr>
                  <th *ngFor="let col of columns" [style.width.px]="col.width">
                    <a (click)="setSorting(col.key)">{{ col.label }}
                      <i class="fa fa-thin" [ngClass]="orderBy === col.key ? stylesortBy : 'fa-angle-down'"></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="loadFlag2">
                  <tr class="loader">
                    <td [attr.colspan]="columns.length">
                      <div class="loader-container"><img class="table-loader" src="../../../assets/images/loading.svg"></div>
                    </td>
                  </tr>
                </ng-container>

                <ng-container *ngIf="!loadFlag2 && rows.length">
                  <tr *ngFor="let tx of rows">
                    <td *ngFor="let col of columns" [style.width.px]="col.width" [attr.data-th]="col.label" [ngSwitch]="col.type">
                      <div *ngSwitchCase="'date'">{{ tx[col.key] ? (tx[col.key] | date:'MM/dd/yyyy') : '--' }}</div>
                      <div *ngSwitchCase="'money'">{{ tx[col.key] != null ? (tx[col.key] | currency:'USD':'symbol':'1.2-2') : '--' }}</div>
                      <div *ngSwitchDefault>{{ tx[col.key] != null && tx[col.key] !== '' ? tx[col.key] : '--' }}</div>
                    </td>
                  </tr>
                </ng-container>

                <ng-container *ngIf="!loadFlag2 && !rows.length">
                  <tr class="vamp-empty-row">
                    <td [attr.colspan]="columns.length">
                      <app-message-on-list [message]="noDataMessage" [iconName]="'info'"></app-message-on-list>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div class="row m-0 pt-sm-4 pt-1" *ngIf="!loadFlag2 && totalRecords">
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mb-3">
              <span class="paginate">
                {{ rangeStart }} -
                <select [(ngModel)]="limit" (change)="setUrl()" class="page-limit" *ngIf="page === 1">
                  <option *ngFor="let no of limitArray" [value]="no">{{ no }}</option>
                </select>
                <span *ngIf="page !== 1">{{ rangeEnd }}</span>
                &nbsp;of&nbsp; {{ totalRecords }}
              </span>
            </div>
            <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 text-lg-right text-left">
              <button type="button" class="btn btn-default btn_prenext" [disabled]="page <= 1" (click)="prevPage()">
                <i class="fa fa-angle-double-left" aria-hidden="true"></i> Previous
              </button>
              <span class="mx-2">Page {{ page }} of {{ totalPages }}</span>
              <button type="button" class="btn btn-default btn_prenext" [disabled]="page >= totalPages" (click)="nextPage()">
                Next <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 vamp-disclaimer">
      To inquire about a specific transaction or dispute a transaction, contact
      <a [href]="disputeMailto">Risk&#64;payarc.com</a>
    </div>
  </div>
</div>
